import axios from "axios";
import mapboxgl from "mapbox-gl";
import { RouteEnums } from "../../../../../common/constants";
import moment from "moment/moment";


export default class VehicleRouteFetcher {

  constructor(theme) {
    this._theme = theme;
    this._vehicles = [];
    this._routes = new Map();
    this._working = false;
    this._destroyed = false;
  }

  async update(vehicles) {
    if (this._working || this._destroyed) return;
    this._working = true;

    let nextSet = new Set(vehicles.filter(t => this.hasActiveRoute(t)).map(t => t.routingData.routeId));
    let toRemove = [...this._routes.keys()].filter(routeId => !nextSet.has(routeId));
    let toAdd = [...nextSet].filter(routeId => !this._routes.has(routeId));

    toRemove.forEach(routeId => this._routes.delete(routeId));

    for (let i = 0; i < toAdd.length; i++) {
      if (this._destroyed) return;

      let routeId = toAdd[i];

      let vehicle = vehicles.find(t => t?.routingData?.routeId === routeId);
      let routingData = vehicle?.routingData;

      if (!!routingData) {

        const r = await this.fetchRoute(
          [
            routingData.origin,
            routingData.destination,
          ],
          routingData.heading,
          routingData.maxHeight,
          routingData.maxWidth,
          routingData.maxWeight
        )

        if (!!r) {
          this._routes.set(routeId, { route: r, routingData, vehicle });
        }
      }
    }

    this._vehicles = vehicles;
    this._currentRoutes = new Set([...this._routes.keys()]);
    this._working = false;
  }

  hasActiveRoute(vehicle) {
    if (!vehicle?.routingData?.routeId) return false;

    const r = vehicle.routingData;
    let end = moment(r.created).add(r.duration * 1.25, "seconds");

    return end.isAfter();
  }

  getRouteGeometries() {
    if (this._destroyed) return [];
    return [...this._routes.values()].map(r => ({
      type: "feature",
      geometry: r.route.geometry,
      properties: {
        color: this.getColor(r)
      }
    }));
  }

  getColor(r) {
    switch (r.routingData.navigationType) {

      case RouteEnums.NavigationType.InRoute:
        return this._theme.palette.common.inRoute;
      case RouteEnums.NavigationType.ToRoute:
        return this._theme.palette.common.toRoute;
      default:
        return "rgba(0,0,0,0.6)";
    }
  }

  async fetchRoute(waypoints, bearing = null, maxHeight = 1.6, maxWidth = 1.9, maxWeight = 2500) {
    const queryCoordinates = waypoints.map(t => t.join(",")).join(";");
    const bearingQuery = typeof bearing !== "number" ? "" : `&bearings=${bearing},45;`


    const query = `driving-traffic/${queryCoordinates}?access_token=${mapboxgl.accessToken}${bearingQuery}&alternatives=false${this.excludeMotorway ? "&exclude=motorway" : ""}&language=${this.language}&steps=true&annotations=speed&geometries=geojson&max_height=${maxHeight}&max_width=${maxWidth}&max_weight=${maxWeight / 1000.0}`;
    const res = await axios(`https://api.mapbox.com/directions/v5/mapbox/${query}&overview=full`);

    if (res.data?.routes?.length !== 0) {
      const data = res.data.routes[0];
      return data;
    }

    return null;
  }


  destroy() {
    this._destroyed = true;
    this._routes = null;
  }


}